import { TimeType } from '../dtos/generic'
import { TaskDTO } from '../dtos/task'

export type GenerationCacheOptions = { cacheOptions?: { forceReset?: true } }

type GenerationParams = {
  generationId: string
  organizationId: string
  userId: string
}

export enum GenerationEnum {
  GenerateChatResponse = 'generate_chat_response',
  GenerateCaseWorkerTasks = 'generate_case_worker_tasks',
  GenerateTasks = 'generate_tasks',
  GenerateWelcomeMessage = 'generate_welcome_message',
  GenerateProfileSummary = 'generate_profile_summary', // Legacy before objtectives
  GenerateCaseworkerDashboard = 'generate_caseworker_dashboard',
  GenerateBeneficiaryTips = 'generate_beneficiary_tips',
}

export enum GenerationStatusEnum {
  Streaming = 'streaming',
  Finished = 'finished',
}

export type GenerationEvent<PayloadType> = {
  status: GenerationStatusEnum
  generationId: string
  payload?: PayloadType
}

export type GenerateProfileSummaryParams = {
  beneficiaryId: string
  chatSessionId?: string
} & GenerationParams

export type GenerateReportParams = {
  beneficiaryId: string
  instructions: string
} & GenerationParams

export type GenerateCaseworkerDashboardParams = {
  asCaseWorkerId: string
} & GenerationParams

export type GenerateChatResponseParams = {
  message: string
  beneficiaryId: string
  chatSessionId: string
  generationId: string
  organizationId: string
}

export type GenerationTasksParams = {
  context: string
  beneficiaryId: string
  tasks: TaskDTO[]
} & GenerationParams

export type GenerateWelcomeMessageParams = {
  beneficiaryId: string
  chatSessionId: string
  generationId: string
  organizationId: string
}

export type GenerateBeneficiaryTipsParams = {
  beneficiaryId: string
} & GenerationParams

export type GenerateBeneficiaryProfileParams = {
  beneficiaryId: string
} & GenerationCacheOptions &
  GenerationParams

export type GenerateBeneficiaryStructuredDataParams = {
  beneficiaryId: string
} & GenerationCacheOptions &
  GenerationParams

export type GenerationAnswerAboutBeneficiaryParams = {
  beneficiaryId: string
  conversationHistory: { messages: ConversationMessageDTO[] }
} & GenerationParams

export type GenerationAnswerAboutBeneficiariesParams = {
  conversationHistory: { messages: ConversationMessageDTO[] }
} & GenerationParams

export type GenerationCaseWorkerTasksParams = {
  beneficiaryId: string
  previouslyGeneratedTasks: {
    title: string
    content: string
  }[]
} & GenerationParams

export type ConversationMessageDTO = {
  content: string
  sender: 'user' | 'assistant'
  sentAt: TimeType
}
